import { getMap } from '@/lib/map/instance';
import { isSearchAreaUnderCrosshair } from '@/lib/map/layers/oiSearchArea';
import { useOiStore } from '@/lib/store/oi';
import { useUiStore } from '@/lib/store/ui';
import { useEffect, useState } from 'react';

/** Fixed crosshair at the main map's centre — the point Set Focus moves the
 *  DSS search box to (carried over from the old RTM Services DSS map).
 *  3rd Party only. */
export function SearchCrosshair() {
  const ctx = useUiStore((s) => s.activeContext);
  const category = useOiStore((s) => s.category);
  if (ctx !== 'oi' || category !== '3rdparty') return null;
  return <Crosshair />;
}

function Crosshair() {
  const center = useOiStore((s) => s.searchArea.center);
  const [underBox, setUnderBox] = useState(false);

  useEffect(() => {
    // The map is created by MapCanvas before the user can reach 3rd Party;
    // without one the crosshair just stays at full strength.
    const map = getMap();
    if (!map) return;
    const update = () => setUnderBox(isSearchAreaUnderCrosshair(map, center));
    update();
    // `resize`: a panel or the window changed the map's size, which moves the
    // centre in screen space. The crosshair itself is CSS-centred on the same
    // box, and lib/map/instance keeps the canvas measured, so the two agree.
    map.on('move', update);
    map.on('resize', update);
    return () => {
      map.off('move', update);
      map.off('resize', update);
    };
  }, [center]);

  return (
    // Dims while the box is already centred here; full strength once the map
    // is panned away, as a cue that Set Focus will move the box.
    <div
      className="pointer-events-none absolute left-1/2 top-1/2 z-5 -translate-x-1/2 -translate-y-1/2 text-(--color-green) transition-opacity"
      style={{ opacity: underBox ? 0.25 : 1 }}
    >
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        role="img"
        aria-label="Map centre"
      >
        <title>Map centre</title>
        <line x1="14" y1="2" x2="14" y2="10" stroke="currentColor" strokeWidth="2" />
        <line x1="14" y1="18" x2="14" y2="26" stroke="currentColor" strokeWidth="2" />
        <line x1="2" y1="14" x2="10" y2="14" stroke="currentColor" strokeWidth="2" />
        <line x1="18" y1="14" x2="26" y2="14" stroke="currentColor" strokeWidth="2" />
        <circle cx="14" cy="14" r="4" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    </div>
  );
}
